// 082 T17 · 质量五态徽章（certified/pass/needs_revision/human_review/blocked + settlement_required 阻塞）
// 数据源：jobs.quality_status（认证态）+ jobs.status（settlement_required 优先显示为阻塞）。
// 失效感知：组件只渲染后端派生值，不本地推导（certificationStatus 的 revision 比对在 API 侧）。

const QUALITY_LABEL: Record<string, { label: string; tone: "ok" | "warn" | "err" | "info" }> = {
  certified: { label: "已认证", tone: "ok" },
  pass: { label: "内容通过", tone: "info" },
  needs_revision: { label: "待修订", tone: "warn" },
  human_review: { label: "人工复核", tone: "warn" },
  blocked: { label: "已阻塞", tone: "err" },
};

export function QualityBadge({ qualityStatus, jobStatus }: {
  qualityStatus: string | null | undefined;
  jobStatus: string | null | undefined;
}) {
  // 阻塞态优先（落库受阻——恢复中的可恢复状态，见 082 T03）
  if (jobStatus === "settlement_required") {
    return <span className="aim-quality-badge is-warn" title="LLM 内容已安全保存，落库受阻，等待自动恢复">结算受阻·恢复中</span>;
  }
  if (!qualityStatus) return null;
  const q = QUALITY_LABEL[qualityStatus];
  if (!q) return <span className="aim-quality-badge is-info">{qualityStatus}</span>;
  return (
    <span className={`aim-quality-badge is-${q.tone}`} title={`质量判定：${q.label}（编辑内容后自动失效，需重新认证）`}>
      {q.label}
    </span>
  );
}
